import { Building2, Mail, MessageSquare, Target, TrendingUp, Trophy } from "lucide-react";

/**
 * Top-of-dashboard KPI grid. Builds a 7-card row from the /dashboard/stats payload.
 */
export default function StatStrip({ stats }) {
  if (!stats) return null;
  const cards = [
    { label: "Profile complete", value: `${stats.profile_completion}%`, icon: Target, accent: stats.profile_completion === 100 },
    { label: "Total targets", value: stats.total_targets, icon: Building2 },
    { label: "Brands contacted", value: stats.contacted, icon: Mail },
    { label: "Replies", value: stats.replies, icon: MessageSquare },
    { label: "Active deals", value: stats.active_deals, icon: TrendingUp },
    { label: "Won", value: stats.won_deals, icon: Trophy, accent: stats.won_deals > 0 },
    { label: "Pipeline value", value: `£${Number(stats.pipeline_value || 0).toLocaleString()}`, icon: TrendingUp, wide: true },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="kpi-grid">
      {cards.map((c, i) => (
        <div key={i} className={`surface p-5 ${c.wide ? "col-span-2 md:col-span-2" : ""} ${c.accent ? "border-volt" : ""}`}>
          <div className="flex items-start justify-between">
            <div className="label-eyebrow">{c.label}</div>
            <c.icon className={`w-4 h-4 ${c.accent ? "text-volt" : "text-ink-muted"}`} />
          </div>
          <div className={`font-heading text-3xl md:text-4xl uppercase mt-3 ${c.accent ? "text-volt" : ""}`}>{c.value}</div>
        </div>
      ))}
    </div>
  );
}
